import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutReferenceNumberCompareItem extends Layout {
    sourceEdiCompareItem: DataSource;
    tableCompareItems: Table;
}
